export enum UserType {
    DayGuest = "dayGuest",
    EveningGuest = "eveningGuest",
}